import styled from "styled-components";

export const SSelectProjectStepListsWrapper = styled.div`
  display: flex;
`;
